import types from '../../actions.types';

const { PENDING, SUCCESS, FAILED, SET_IS_COMPANY_SELECTED } = types.companies;

const defaultState = {
  pending: false,
  data: {},
  error: null,
  isCompanySelected: false
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case PENDING:
      return Object.assign({}, state, { pending: true });
    case SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        data: action.data.data
      });
    case FAILED:
      return Object.assign({}, state, {
        pending: false,
        data: [],
        error: action.error
      });
    case SET_IS_COMPANY_SELECTED: 
      return Object.assign({}, state, {
        isCompanySelected: action.data
      });
    default:
      return state;
  }
}